import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';
import { UpdateCircuit, updateCircuit } from '~/generated';
import { extractData } from '~/utils/query-utils';

export const useEditCircuit = (
  id: number,
  options: UseMutationOptions<unknown, unknown, UpdateCircuit, unknown>
) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (values: UpdateCircuit) =>
      extractData(
        updateCircuit({
          body: {
            id: id,
            ...values,
          },
        })
      ),
    ...options,
    onSuccess(...args) {
      queryClient.invalidateQueries({
        queryKey: ['circuits'],
      });
      options.onSuccess?.(...args);
    },
  });
};
